export default __webpack_public_path__ + "static/media/andromeda.guia-2.b9d35197.png";